import { IconButton, Typography, Button, MenuItem, Grid, ListItemText, Checkbox, FormControlLabel } from '@material-ui/core';
import ValidatedSelect from 'components/ui/form/ValidatedSelect';
import ValidatedTextField from 'components/ui/form/ValidatedTextField';
import FormGroup from '@material-ui/core/FormGroup';
import RoomIcon from '@material-ui/icons/Room';
import ReplayIcon from '@material-ui/icons/Replay';
import MapIcon from '@material-ui/icons/Map';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { useEffect, useState, useRef, forwardRef } from 'react';
import ReactMapGL, { Marker, Popup, NavigationControl, FlyToInterpolator } from 'react-map-gl';
import useSupercluster from 'use-supercluster';
import Supercluster from 'supercluster';
import MaterialTable from 'material-table';
import Tooltip from '@material-ui/core/Tooltip';
import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { Link } from 'react-router-dom';
import * as GeoJSON from 'geojson';
import SearchModal from 'components/ui/form/SearchModal';
import { getAuthHeader, getCognitoUserInfo } from '../auth'
import ValidatedMultiSelect from 'components/ui/form/ValidatedMultiSelect';
import MultiSelect from "react-multi-select-component";
import Modal from 'react-modal';
import LoadingOverlay from 'react-loading-overlay';
// Modal.setAppElement('#searchPageContainer')

const axios = require('axios').default;
const { api, apiKey, apiEndpoint } = require('../../config')

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      // flex: 1,
      minWidth:1200
    },
    navStyle: {
      position: 'absolute',
      top: 36,
      left: 0,
      padding: '10px'
    },
    specialitiesMultiDrop: {
      width: '92%',
      margin: 'auto',
      borderRadius: 4,
      marginTop: 10,
      marginBottom: 5,
      maxWidth: 300,
      marginLeft: 5
    },
    popupStyle: {
      'max-width': '25rem',
      'max-height': '26rem',
    },
    popupAttrStyle: {
      'font-size': '10pt',
      'background-color': '#FFFFFF',
      'padding': '10px 10px',
      'border-radius': '5px'
    },
    popupDescStyle: {
      'font-size': '10pt',
      'background-color': '#FFFFFF',
      'padding': '10px 10px',
      'border-radius': '5px',
    },
    popupTitleStyle: {
      'font-size': '16pt',
    },
    availableIcon: {
      'color': '#00AD26'
    },
    employedAvailableIcon: {
      'color': '#FAC10C'
    },
    employedUnavailableIcon: {
      'color': '#AD0014'
    },
    markerStyle: {
      'padding': '4px'
    },
    clusterMarker: {
      'color': '#fff',
      'background-color': '#1978c8',
      'border-radius': '50%',
      'padding': '10px',
      'display': 'flex',
      'justify-content': 'center',
      'align-items': 'center'
    },
    filterForm: {
      'width': '100%',
      'margin-top': '20px'
    },
    form: {
      // padding: '.5vw 2vw', 
      // border: '1px solid #6D9E11', 
      // borderRadius: '4px',
      // width: '30rem'
    },
    mapOverlay: {
      'position': 'absolute',
      'bottom': '0',
      'right': '0',
      'background': 'rgba(255, 255, 255, 0.8)',
      'margin-right': '20px',
      'font-family': 'Arial, sans-serif',
      'overflow': 'auto',
      'border-radius': '3px'
    },
    legend: {
      'padding': '10px',
      'box-shadow': '0 1px 2px rgba(0, 0, 0, 0.1)',
      'line-height': '18px',
      'height': '130px',
      'margin-bottom': '40px',
      'width': '200px'
    },
    filterButton: {
      'margin': '0 0 0 10px',
      'padding': '6px 10px'
    },
    doneButton: {
      'display': 'flex',
      'marginTop': '10px',
      'margin': 'auto',
    },
    searchField: {
      margin: '0 10px',
      width: '90%'
    },
    indent: { marginLeft: '1em', fontSize: '1rem' },
    columnListValue: { 'white-space': 'nowrap' }
  }),
);
export interface FilterForm {
  EMPLOYMENT_TYPE: string,
  EMPLOYED: string
}
export class FilterFormImpl implements FilterForm {
  EMPLOYMENT_TYPE: string = '';
  EMPLOYED: string = '';
}

export class ProfileForm {
  specialities: Array<String> = [];
  licenseStatus: string = "";
  role: string = "";
  willingToTravel: string = "";
  license: string = "";
  lowerSalary: string = "";
  upperSalary: string = "";
  populationExperience: string = "";
  maxTravelMiles: string = "";
  employmentType: string = "";
  recentExperience: string = "";
  availableToStart: string = "";
  treatCovidPatients: string = "";
  treatCriticalCarePatients: string = "";
  proxZip: string = "";
  proxDistance: string = "";
}

const tableIcons = {
  Add: forwardRef<SVGSVGElement>((props: any, ref: any) => <AddBox {...props} ref={ref} />),
  Check: forwardRef<SVGSVGElement>((props: any, ref: any) => <Check {...props} ref={ref} />),
  Clear: forwardRef<SVGSVGElement>((props: any, ref: any) => <Clear {...props} ref={ref} />),
  Delete: forwardRef<SVGSVGElement>((props: any, ref: any) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef<SVGSVGElement>((props: any, ref: any) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef<SVGSVGElement>((props: any, ref: any) => <Edit {...props} ref={ref} />),
  Export: forwardRef<SVGSVGElement>((props: any, ref: any) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef<SVGSVGElement>((props: any, ref: any) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef<SVGSVGElement>((props: any, ref: any) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef<SVGSVGElement>((props: any, ref: any) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef<SVGSVGElement>((props: any, ref: any) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef<SVGSVGElement>((props: any, ref: any) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef<SVGSVGElement>((props: any, ref: any) => <Clear {...props} ref={ref} />),
  Search: forwardRef<SVGSVGElement>((props: any, ref: any) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef<SVGSVGElement>((props: any, ref: any) => <ArrowUpward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef<SVGSVGElement>((props: any, ref: any) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef<SVGSVGElement>((props: any, ref: any) => <ViewColumn {...props} ref={ref} />)
};

const availableTravelDistances: string[] = [
  "Any",
  "up to 25 miles",
  "up to 50 miles",
  "up to 75 miles",
  "up to 100 miles",
  "anywhere"
];
const availableProxDistances: string[] = [
  "5",
  "25",
  "50",
  "75",
  "100"
];
const availableToStartOptions: string[] = [
  "Any",
  // "Now",
  "Within 2 weeks",
  "Within 1 month",
  "Within 2 months",
  "More than 2 months",
  "Unknown"
];
const availableEmploymentTypes: string[] = [
  "Any",
  "All",
  "Medical",
  "Non-Medical"
];

const availableLicenses: string[] = [
  "Any",
  "Certified Nurse Practitioner",
  "Clinical Nurse Specialist",
  "Dialysis Technician (DT)",
  "Licensed Practical Nurse (LPN)",
  "Registered Nurse (RN)",
  "Volunteer Certificate (VC)"
];

const availableLicenseStatuses: string[] = [
  "Any",
  "Active Medical License",
  "Expired Medical License",
  "Student",
];

const availableRoles: string[] = [
  "Any",
  "Full Time",
  "Part Time",
];

const availableSpecialities: any = [
  {
    "label": "Nurse - Advanced Practice Nurse",
    "value": "Nurse - Advanced Practice Nurse"
  },
  {
    "label": "Nurse - Certified Nurse Specialist",
    "value": "Nurse - Certified Nurse Specialist"
  },
  {
    "label": "Nurse - Licensed Practical Nurse",
    "value": "Nurse - Licensed Practical Nurse"
  },
  {
    "label": "Nurse - Nurse Anesthetist",
    "value": "Nurse - Nurse Anesthetist"
  },
  {
    "label": "Nurse - Nurse Practitioner",
    "value": "Nurse - Nurse Practitioner"
  },
  {
    "label": "Nurse - Registered Professional Nurse",
    "value": "Nurse - Registered Professional Nurse"
  },
  {
    "label": "Nurse - School Nurse",
    "value": "Nurse - School Nurse"
  },
  {
    "label": "Mental Health - Counselor",
    "value": "Mental Health - Counselor"
  },
  {
    "label": "Mental Health - Licensed Clinical Social Worker",
    "value": "Mental Health - Licensed Clinical Social Worker"
  },
  {
    "label": "Mental Health - Psychologist",
    "value": "Mental Health - Psychologist"
  },
  {
    "label": "Mental Health Professional - Other",
    "value": "Mental Health Professional - Other"
  },
  {
    "label": "Physician - Anesthesiologist",
    "value": "Physician - Anesthesiologist"
  },
  {
    "label": "Physician - Emergency Department",
    "value": "Physician - Emergency Department"
  },
  {
    "label": "Physician - Family Medicine",
    "value": "Physician - Family Medicine"
  },
  {
    "label": "Physician - Infectious Disease",
    "value": "Physician - Infectious Disease"
  },
  {
    "label": "Physician - Intensive Care",
    "value": "Physician - Intensive Care"
  },
  {
    "label": "Physician - Internal Medicine",
    "value": "Physician - Internal Medicine"
  },
  {
    "label": "Physician - OB/GYN",
    "value": "Physician - OB/GYN"
  },
  {
    "label": "Physician - Psychiatrist",
    "value": "Physician - Psychiatrist"
  },
  {
    "label": "Physician - Pulmonologist",
    "value": "Physician - Pulmonologist"
  },
  {
    "label": "Physician - Radiologist",
    "value": "Physician - Radiologist"
  },
  {
    "label": "Physician - Surgeon",
    "value": "Physician - Surgeon"
  },
  {
    "label": "Physician - Other",
    "value": "Physician - Other"
  },
  {
    "label": "Respiratory Therapist",
    "value": "Respiratory Therapist"
  },
  {
    "label": "Respiratory Therapy Technician",
    "value": "Respiratory Therapy Technician"
  },
  {
    "label": "Acupuncturist",
    "value": "Acupuncturist"
  },
  {
    "label": "Certified Home Health Aide",
    "value": "Certified Home Health Aide"
  },
  {
    "label": "Certified Nurse Aide",
    "value": "Certified Nurse Aide"
  },
  {
    "label": "Chiropractor",
    "value": "Chiropractor"
  },
  {
    "label": "Clinical Laboratory Technician",
    "value": "Clinical Laboratory Technician"
  },
  {
    "label": "Clinical Laboratory Technologist",
    "value": "Clinical Laboratory Technologist"
  },
  {
    "label": "Clinical Nurse Specialist",
    "value": "Clinical Nurse Specialist"
  },
  {
    "label": "Dental Hygienist",
    "value": "Dental Hygienist"
  },
  {
    "label": "Dentist",
    "value": "Dentist"
  },
  {
    "label": "Doula",
    "value": "Doula"
  },
  {
    "label": "Emergency Medical Technician (EMT)",
    "value": "Emergency Medical Technician (EMT)"
  },
  {
    "label": "Licensed Clinical Social Worker",
    "value": "Licensed Clinical Social Worker"
  },
  {
    "label": "Medical Assistant",
    "value": "Medical Assistant"
  },
  {
    "label": "Medical Technologist",
    "value": "Medical Technologist"
  },
  {
    "label": "Midwife",
    "value": "Midwife"
  },
  {
    "label": "Mobility Assistant Vehicle Operator/Livery Service",
    "value": "Mobility Assistant Vehicle Operator/Livery Service"
  },
  {
    "label": "Occupational Therapist",
    "value": "Occupational Therapist"
  },
  {
    "label": "Optometrist",
    "value": "Optometrist"
  },
  {
    "label": "Other Critical Care Medicine",
    "value": "Other Critical Care Medicine"
  },
  {
    "label": "Paramedic",
    "value": "Paramedic"
  },
  {
    "label": "Perfusionist",
    "value": "Perfusionist"
  },
  {
    "label": "Pharmacist",
    "value": "Pharmacist"
  },
  {
    "label": "Phlebomotist",
    "value": "Phlebomotist"
  },
  {
    "label": "Physician Assistant",
    "value": "Physician Assistant"
  },
  {
    "label": "Podiatrist",
    "value": "Podiatrist"
  },
  {
    "label": "Rehabilitation Counselor",
    "value": "Rehabilitation Counselor"
  },
  {
    "label": "Respiratory Therapists",
    "value": "Respiratory Therapists"
  },
  {
    "label": "Specialist Assistant",
    "value": "Specialist Assistant"
  },
  {
    "label": "Sports Medicine / Athletic Trainer",
    "value": "Sports Medicine / Athletic Trainer"
  },
  {
    "label": "Veterinary Technician (Vet Tech)",
    "value": "Veterinary Technician (Vet Tech)"
  },
  {
    "label": "Veterinarian",
    "value": "Veterinarian"
  },
  {
    "label": "X-Ray Technician",
    "value": "X-Ray Technician"
  }
]

const availableRecentExperienceOptions: string[] = [
  "Any",
  "Currently Practicing",
  "Within Past 6 Months",
  "6 Months - 2 Years",
  "Over 2 Years Ago"
];

const availableBoolean: string[] = [
  "Any",
  "Yes",
  "No",
];

let profileForm = new ProfileForm();
export default function PeoplePage(props: any) {
  const [form, setForm] = useState<ProfileForm>(profileForm);
  const [showPopover, setshowPopover] = useState(false)
  const classes = useStyles(props.theme);
  const [viewport, setViewport] = useState({
    latitude: 38.8283,
    longitude: -96.5795,
    width: "100hw",
    height: "100vh",
    zoom: 3.8,
    transitionInterpolator: null,
    transitionDuration: "auto"
  });
  const cognitoUserInfo = getCognitoUserInfo() || {}
  const [searchModalVisibility, setSearchModalVisibility] = useState<Boolean>(false)
  const [activeResults, setActiveResults] = useState<any>("table");
  const [searchTerm, setSearchTerm] = useState<any>("");
  const [filterString, setFilterString] = useState<any>({});
  const [proxZip, setProxZip] = useState<any>(null);
  const [proxDistance, setProxDistance] = useState<any>(null);
  const [fieldsString, setFieldsString] = useState<any>(
    "id,email,firstName,lastName,address.line1,address.lat,address.lon,address.zipCode,populationExperience,licenseStatus,treatCovidPatients,specialities,phoneNumber,licenses,recentExperience,willRelocate,maxTravelMiles,availableToStart,resumeFilename"
  );
  const [selectedSpecialities, setselectedSpecialities] = useState([]);
  const [isLoading, setisLoading] = useState(false)
  const [filteredResources, setFilteredResources] = useState<any>([]);
  const [selectedResource, setSelectedResource] = useState<any>();
  const mapRef = useRef<any>();
  const points = filteredResources as Supercluster.PointFeature<GeoJSON.GeoJsonProperties>[];
  const bounds = mapRef.current ? mapRef.current
    .getMap()
    .getBounds()
    .toArray()
    .flat()
    : null;
  const customStyles = {
    content: {
      left: 'auto',
      right: 'auto',
      bottom: 'auto',
      margin: '10%'
    }
  };
  const filteredResourcesProperties = filteredResources.map((a: any) => a.properties);
  const { clusters, supercluster } = useSupercluster({
    points,
    bounds,
    zoom: viewport.zoom,
    options: { radius: 40, maxZoom: 7 }
  });
  const [savedFilters, setsavedFilters] = useState([])
  const getFilters = async () => {
    await axios({
      method: 'GET',
      url: `${apiEndpoint}/users/filters?id=${cognitoUserInfo.sub}`,
      headers: {
        'x-api-key': apiKey,
        Authorization: getAuthHeader()
      }
    }).then((response: any) => {
      if (response && response.data) {
        setsavedFilters(response.data.data)
      }
    }).catch((err: any) => {
      console.log({ err })
    })
  }
  useEffect(() => {
    Promise.all([getFilters(),
    getData(filterString)])
  }, [])
  const handleSearchModalOpen = () => {
    setSearchModalVisibility(true);
  };

  const handleSearchModalClose = () => {
    setSearchModalVisibility(false);
  };
  const getData = async (filterString: any) => {
    console.log({ filterString })
    setisLoading(true)
    await axios({
      method: 'POST',
      url: `${apiEndpoint}/users/within-radius?fields=${fieldsString}&proxZip=${proxZip ? proxZip : '30346'}&proxDistance=${proxDistance ? proxDistance : '3000'}`,
      data: {
        filters: filterString
      },
      headers: {
        'x-api-key': apiKey,
        Authorization: getAuthHeader()
      }
    })
      .then((response: any) => {
        setisLoading(false)
        if (response.data) {
          let withLocation = response.data.data.filter((responseData: any) => {
            if (responseData.lat) {
              return true;
            }
            return false;
          });
          let theseResources = {
            "type": "FeatureCollection",
            "features": transformResources(withLocation)
          }
          setFilteredResources(theseResources.features);
        } else {
          console.log('could not load search data');
        }
      })
      .catch((err: Error) => {
        setisLoading(false)
        console.log('error: ', err);
      });
  }
  const onChangeUserFilters = (event: any) => {
    const { value, name } = event.target
    let filter = savedFilters.filter((item: any) => item.filterName == value)
    let { filterQuery = '{}' } = filter[0]
    let applyFilterQuery: ProfileForm = JSON.parse(filterQuery)
    setFilterString(applyFilterQuery)
    setForm(applyFilterQuery)
    getData(applyFilterQuery)
  }
  const transformResources = (tempData: any) => {
    let returnData = [];
    returnData = tempData.map((currentItem: any) => {
      let returnItem =
      {
        "type": "Feature",
        "geometry": {
          "type": "Point",
          "coordinates": [currentItem.lon, currentItem.lat]
        },
        "properties": {
          "cluster": false,
          "id": currentItem.id,
          "email": currentItem.email,
          "name": currentItem.first_name + ' ' + currentItem.last_name,
          "populationExperience": currentItem.population_experience,
          "zipCode": currentItem.address_zip_code,
          "treatCovidPatients": currentItem.treat_covid_patients,
          "relocatable": currentItem.willRelocate,
          "maxTravelMiles": currentItem.maxTravelMiles,
          "specialities": currentItem.specialities,
          "phoneNumber": currentItem.phone,
          "licenses": currentItem.licenses,
          "availableToStart": currentItem.availableToStart,
          "recentExperience": currentItem.recent_experience,
          "resumeFilename": currentItem.resume_filename
        }
      }
      return returnItem;
    });
    return returnData;
  };

  let toggleResultsView = () => {
    if (activeResults == "map") {
      setActiveResults("table");
    }
    else {
      setActiveResults("map");
    }
  }

  let clearFilters = () => {
    setForm(new ProfileForm());
    setProxDistance(null);
    setFilterString({})
    setProxZip(null)
    setselectedSpecialities([])
    getData({})
  }
  let onChangeSpecialities = (specialities: any) => {
    setselectedSpecialities(specialities)
    let filterObj = JSON.parse(JSON.stringify(filterString))
    filterObj['specialities'] = specialities.map((item: any) => item.label)
    let updatedForm = {
      ...form,
      specialities: specialities.map((item: any) => item.label)
    }
    setForm(updatedForm);
    setFilterString(filterObj);
  }
  let onChange = (event: React.ChangeEvent<HTMLInputElement | { name?: string, value: any, checked?: boolean }>) => {
    let { value, name = '' } = event.target;
    let filterObj = JSON.parse(JSON.stringify(filterString))
    switch (name) {
      case 'proxDistance':
        if (value) {
          setProxDistance(value);
        }
        break;
      case 'proxZip':
        if (value && typeof value == "string" && value.length > 4) {
          setProxZip(value);
        }
        break;
      case 'specialities':
      case 'populationExperience':
      case 'license':
      case 'recentExperience':
      case 'licenseStatus':
      case 'recentExperience':
      case 'role':
      case 'willingToTravel':
      case 'travelDistance':
      case 'availableToStart':
      case 'treatCovidPatients':
      case 'treatCritical':
        if (value != 'All' && value != 'Any' && value != '') {
          filterObj[name] = typeof (value) === 'string' ? value.trim() : value
        }
        else {
          delete filterObj[name]
          value = '';
        }
        break;
    }
    let updatedForm = {
      ...form,
      [event.target.name || ""]: typeof (value) === 'string' ? value.trim() : value
    }
    setForm(updatedForm);
    setFilterString(filterObj);
  }

  let downloadResume = (email: string, resumeFileName: string) => {

    const opts = {
      url: `${apiEndpoint}/profile/download-url?userEmail=${email}&fileName=${resumeFileName}`,
      method: 'GET',
      headers: {
        'Authorization': getAuthHeader(),
        'x-api-key': apiKey
      }
    }

    axios(opts).then((response: { data: { url: string | undefined; }; }) => {
      if (response && response.data && response.data.url) {
        window.open(response.data.url, '_blank');
      }
    });
  }

  let formatPhone = (phone: string) => {
    let numbers = ('' + phone).replace(/\D/g, '');

    let parts = numbers.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (parts) {
      let code = (parts[1] ? '+1 ' : '')
      return [code, '(', parts[2], ') ', parts[3], '-', parts[4]].join('')
    }

    return null;
  }

  const formatLicenses: any = (licenses?: any, format?: number) => {
    // number: undefined or 0 = name only; 1 = name and number
    let r: any = '';
    if (licenses && licenses !== '') {
      const all = licenses.split(';');
      const clean: string[] = all.map((lic: string) => {
        let jlic = JSON.parse(JSON.stringify(lic));
        let ret: string[] = [];
        ret.push(jlic.name);
        if (format !== undefined && format === 1) {
          ret.push(' (', jlic.number, ')');
        }
        return ret.join('');
      });
      if (format && format === 2) {
        r = clean;
      } else {
        r = clean.join(', ');
      }
    }
    return r;
  }

  const getLastElement = (arr: any[]) => {
    return (arr[Math.max(0, arr.length - 1)]);
  }

  let resourceIcon = (selectedResource: any) => {
    return <RoomIcon className={classes.availableIcon} />
  }

  // useEffect(() => {
  //   getData(filterString);
  // }, [searchTerm, filterString, fieldsString, form]);

  let resourcePopupDetail = (selectedResource: any) => {
    return (
      <div>
        <h2 className={classes.popupTitleStyle}>{resourceIcon(selectedResource)} {selectedResource.properties.name}</h2>
        <p className={classes.popupAttrStyle}>
          {/* <b>Population Exp: </b>
            {selectedResource.properties.populationExperience && selectedResource.properties.populationExperience[0] !== "" ? selectedResource.properties.populationExperience.join(', ') : 'None'}<br /> */}
          <b>Specialities:</b> {selectedResource?.properties?.specialities?.toString()}<br />
          <b>Phone:</b> {formatPhone(selectedResource.properties.phoneNumber)}<br />
          <b>Email</b> {selectedResource.properties.email}<br />
          <b>Start Date</b> {selectedResource.properties.availableToStart}<br />
          <b>Resume</b> {(selectedResource.properties.resumeFilename && <Link to='#' target='_self' onClick={(e) => { e.nativeEvent.stopImmediatePropagation(); downloadResume(selectedResource.properties.email, selectedResource.properties.resumeFilename) }}>{decodeURIComponent(selectedResource.properties.resumeFilename)}</Link>) || 'None provided'}<br />
        </p>
        <p className={classes.popupDescStyle}>
          <b>Licenses:</b> {formatLicenses(selectedResource.properties.licenses, 1)}<br />
          <b>Recent Experience:</b> {selectedResource.properties.recentExperience}<br />
          <b>Will Treat Covid Patients:</b> {selectedResource.properties.treatCovidPatients}<br />

        </p>
        <p className={classes.popupDescStyle}>
          <b>Contact Info:</b> <Button size="small" variant="contained" disabled>Link to Contact Info</Button><br />
          <b>Notes:</b> {selectedResource.properties.NOTES}
        </p>
      </div>
    );
  }

  return (
    <div className={classes.root} id='searchPageContainer'>
      <LoadingOverlay
        active={isLoading}
        spinner
        text='Loading ...'
      >
        <main>
          <Grid container spacing={0}>
            <Grid item xs={3}>
              <FormGroup row className={classes.filterForm}>
                <form className={classes.form}>
                  <Grid container>

                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        className={classes.filterButton}
                        color="primary"
                        onClick={clearFilters}
                      >
                        <ReplayIcon />&nbsp;Reset
                    </Button>
                      <Button
                        variant="contained"
                        className={classes.filterButton}
                        color="primary"
                        onClick={toggleResultsView}
                      >
                        {activeResults == 'map' ? 'Table' : 'Map'}&nbsp;{activeResults == 'map' ? <ListAltIcon /> : <MapIcon />}
                      </Button>
                    </Grid>
                    {savedFilters.length > 0 ?
                      <Grid item xs={12}>
                        <ValidatedSelect
                          id="userFilters"
                          labelId="userFilters-label"
                          name="userFilters"
                          // value={form.userFilters}
                          onChange={onChangeUserFilters}
                          label="Saved Queries">
                          {savedFilters.map((item: any) => (
                            <MenuItem key={item.filterName} value={item.filterName}>
                              <ListItemText primary={item.filterName} />
                            </MenuItem>
                          ))}
                        </ValidatedSelect>
                      </Grid> : null}
                    {/* <Grid item xs={12}>
                      <ValidatedTextField
                        name="proxZip"
                        label="Zip Code"
                        value={form.proxZip}
                        onChange={onChange}
                      />
                      <ValidatedSelect
                        id="proxDistance"
                        labelId="proxDistance-label"
                        name="proxDistance"
                        value={form.proxDistance}
                        onChange={onChange}
                        label="Distance From Zip(Miles)">
                        {availableProxDistances.map((name) => (
                          <MenuItem key={name} value={name}>
                            <ListItemText primary={name} />
                          </MenuItem>
                        ))}
                      </ValidatedSelect>
                    </Grid> */}
                    <Grid item xs={12}>
                      {/* <div style={{display:'inline-block',marginLeft:15}}>Specialities</div> */}
                      <MultiSelect
                        options={availableSpecialities} // Options to display in the dropdown
                        value={selectedSpecialities}
                        className={classes.specialitiesMultiDrop}
                        onChange={onChangeSpecialities} // Function will trigger on select event
                        displayValue="Specialities" // Property name to display in the dropdown options
                        hasSelectAll={false}
                        overrideStrings={{ "selectSomeItems": "Select Specialities..." }}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <ValidatedSelect
                        id="populationExperience"
                        labelId="population-experience-label"
                        name="populationExperience"
                        value={form.populationExperience}
                        onChange={onChange}
                        label="Population Experience"
                      >
                        <MenuItem key="All" value="All">
                          <ListItemText primary="All" />
                        </MenuItem>
                        <MenuItem key="Pediatrics" value="Pediatrics">
                          <ListItemText primary="Pediatrics" />
                        </MenuItem>
                        <MenuItem key="Adults" value="Adults">
                          <ListItemText primary="Adults" />
                        </MenuItem>
                        <MenuItem key="Geriatrics" value="Geriatrics">
                          <ListItemText primary="Geriatrics" />
                        </MenuItem>
                      </ValidatedSelect>
                    </Grid>
                    <Grid item xs={12}>
                      <ValidatedSelect
                        id="license"
                        labelId="license-label"
                        name="license"
                        value={form.license}
                        onChange={onChange}
                        label="License"
                      >
                        {availableLicenses.map((name) => (
                          <MenuItem key={name} value={name}>
                            <ListItemText primary={name} />
                          </MenuItem>
                        ))}
                      </ValidatedSelect>
                    </Grid>
                    <Grid item xs={12}>
                      <ValidatedSelect
                        id="recentExperience"
                        labelId="recentExperience-label"
                        name="recentExperience"
                        value={form.recentExperience}
                        onChange={onChange}
                        label="Most Recent Experience"
                      >
                        {availableRecentExperienceOptions.map((name) => (
                          <MenuItem key={name} value={name}>
                            <ListItemText primary={name} />
                          </MenuItem>
                        ))}
                      </ValidatedSelect>
                    </Grid>
                    <Grid item xs={12}>
                      <ValidatedTextField
                        name="lowerSalary"
                        style={{ width: '8.5em' }}
                        label="Salary From"
                        value={form.lowerSalary}
                        onChange={onChange}
                      />
                      <ValidatedTextField
                        name="upperSalary"
                        style={{ width: '8.5em' }}
                        label="Salary To"
                        value={form.upperSalary}
                        onChange={onChange}
                      />
                    </Grid>
                    {/* <Grid item xs={12}>
                      <ValidatedSelect
                        id="role"
                        labelId="role-label"
                        name="role"
                        value={form.role}
                        onChange={onChange}
                        label="Role"
                      >
                        {availableRoles.map((name) => (
                          <MenuItem key={name} value={name}>
                            <ListItemText primary={name} />
                          </MenuItem>
                        ))}
                      </ValidatedSelect>
                    </Grid> */}
                    {/* <Grid item xs={12}>
                      <ValidatedSelect
                        id="willingToTravel"
                        labelId="travel-label"
                        name="willingToTravel"
                        value={form.willingToTravel}
                        onChange={onChange}
                        label="Willing to Travel"
                      >
                        {availableBoolean.map((name) => (
                          <MenuItem key={name} value={name}>
                            <ListItemText primary={name} />
                          </MenuItem>
                        ))}
                      </ValidatedSelect>
                    </Grid> */}
                    {/* <Grid item xs={12}>
                    <ValidatedSelect
                      id="travelDistance"
                      labelId="travelDistance-label"
                      name="travelDistance"
                      value={form.maxTravelMiles}
                      onChange={onChange}
                      label="Max Travel Distance"
                    >
                      {availableTravelDistances.map((name) => (
                        <MenuItem key={name} value={name}>
                          <ListItemText primary={name} />
                        </MenuItem>
                      ))}
                    </ValidatedSelect>
                  </Grid> */}
                    <Grid item xs={12}>
                      <ValidatedSelect
                        id="availableToStart"
                        labelId="availableToStart-label"
                        name="availableToStart"
                        value={form.availableToStart}
                        onChange={onChange}
                        label="Available To Start"
                      >
                        {availableToStartOptions.map((name) => (
                          <MenuItem key={name} value={name}>
                            <ListItemText primary={name} />
                          </MenuItem>
                        ))}
                      </ValidatedSelect>
                    </Grid>
                    <Grid item xs={12}>
                      <ValidatedSelect
                        id="treatCovidPatients"
                        labelId="treatCovidPatients-label"
                        name="treatCovidPatients"
                        value={form.treatCovidPatients}
                        onChange={onChange}
                        label="Treat Covid in Person"
                      >
                        {availableBoolean.map((name) => (
                          <MenuItem key={name} value={name}>
                            <ListItemText primary={name} />
                          </MenuItem>
                        ))}
                      </ValidatedSelect>
                    </Grid>
                    <Grid item xs={12}>
                      <ValidatedSelect
                        id="treatCritical"
                        labelId="treatCritical-label"
                        name="treatCritical"
                        value={form.treatCriticalCarePatients}
                        onChange={onChange}
                        label="Treat Critical Care in Person"
                      >
                        {availableBoolean.map((name) => (
                          <MenuItem key={name} value={name}>
                            <ListItemText primary={name} />
                          </MenuItem>
                        ))}
                      </ValidatedSelect>
                    </Grid>

                    <Grid style={{ display: 'flex' }} item xs={12}>
                      <Button
                        onClick={() => getData(filterString)}
                        variant="contained" color="primary"
                        // disabled={!(proxZip || proxDistance || Object.keys(filterString).length !== 0)}
                        className={classes.doneButton}
                      >
                        Search
                       </Button>
                      <Button
                        onClick={handleSearchModalOpen}
                        variant="contained" color="primary"
                        disabled={!(proxZip || proxDistance || Object.keys(filterString).length !== 0)}
                        className={classes.doneButton}
                      >
                        Save Query
                       </Button>
                    </Grid>
                  </Grid>
                </form>
              </FormGroup>
            </Grid>
            {activeResults == 'map' ? (
              <Grid item xs={9}>
                <ReactMapGL
                  {...viewport}
                  mapboxApiAccessToken="pk.eyJ1Ijoiandsb25nbyIsImEiOiJja2FiMTZqZ2swcTdnMnFyeXdiMXgwdWF3In0.64kzFeknJf0Cv2Uw7s6hGg"
                  mapStyle="mapbox://styles/jwlongo/ckabgxhj60st31ip6exl6s5iz"
                  maxZoom={20}
                  minZoom={3}
                  ref={mapRef}
                  onViewportChange={((viewport: any) => {
                    setViewport({ ...viewport });

                  })}
                >
                  {clusters.map((cluster: any) => {
                    // every cluster point has coordinates
                    const [longitude, latitude] = cluster.geometry.coordinates;
                    let clusterId = 1;
                    let isCluster = false;
                    let pointCount = 0;
                    if (cluster && cluster.properties) {
                      isCluster = cluster.properties.cluster;
                      pointCount = cluster.properties.point_count;
                    }
                    // we have a cluster to render
                    if (supercluster && isCluster && cluster.properties) {
                      clusterId = cluster.properties.cluster_id;
                      return (
                        <Marker
                          key={`cluster-${clusterId}`}
                          latitude={latitude}
                          longitude={longitude}
                        >
                          <div
                            className={"marker-btn " + classes.clusterMarker}
                            style={{
                              width: `${20 + (pointCount / points.length) * 9.50}px`,
                              height: `${20 + (pointCount / points.length) * 100}px`
                            }}
                            onClick={() => {
                              const expansionZoom = Math.min(
                                supercluster.getClusterExpansionZoom(clusterId),
                                20
                              );

                              setViewport({
                                ...viewport,
                                latitude,
                                longitude,
                                zoom: expansionZoom,
                                transitionInterpolator: new FlyToInterpolator({
                                  speed: 1
                                }),
                                transitionDuration: "auto"
                              });
                            }}
                          >
                            {pointCount}
                          </div>
                        </Marker>);
                    }
                    else {
                      if (cluster.properties && cluster.properties.id != undefined) {
                        clusterId = cluster.properties.id;
                        return (
                          <Marker
                            key={`noncluster-${clusterId}`}
                            latitude={latitude}
                            longitude={longitude}
                          >
                            <IconButton
                              className={"marker-btn " + classes.markerStyle}
                              onClick={e => {
                                e.preventDefault();
                                setSelectedResource(cluster);
                              }}
                            >
                              {cluster && cluster.properties ? resourceIcon(cluster) : null}
                            </IconButton>
                          </Marker>
                        );
                      }
                    }
                  })}
                  {(selectedResource && selectedResource.geometry &&
                    selectedResource.geometry.coordinates && selectedResource.geometry.coordinates[0] &&
                    selectedResource.geometry.coordinates[1]) || showPopover ? (
                      <Popup
                        latitude={selectedResource && selectedResource.geometry ? selectedResource.geometry.coordinates[1] : 0}
                        longitude={selectedResource && selectedResource.geometry ? selectedResource.geometry.coordinates[0] : 0}
                        closeOnClick={false}
                        onClose={() => {
                          setshowPopover(false)
                          setSelectedResource({
                            type: '',
                            properties: {
                              ID: 0,
                              NAME: '',
                              TYPE: '',
                              LICENSE: '',
                              LICENSE_ACTIVE: false,
                              SPECIALTY: '',
                              EMPLOYED: false,
                              EMPLOYMENT_TYPE: '',
                              EMPLOYER: '',
                              COVID_STATUS: '',
                              ZIPCODE: 0,
                              TRAVEL: '',
                              SALARY_RANGE: '',
                              CONTACT_INFO: '',
                              NOTES: '',
                            },
                            geometry: {
                              type: 'point',
                              coordinates: [0, 0]
                            }
                          });
                        }}
                        className={classes.popupStyle}
                      >
                        <div>
                          {resourcePopupDetail(selectedResource)}
                        </div>
                      </Popup>
                    ) : null}
                  <div className={classes.navStyle}>
                    <NavigationControl />
                  </div>
                </ReactMapGL>
                <div className={classes.mapOverlay + ' ' + classes.legend} id='legend'>
                  <div>
                    <RoomIcon className={classes.availableIcon}></RoomIcon>Available
                </div>
                  <div>
                    <RoomIcon className={classes.employedAvailableIcon}></RoomIcon>Employed/Non-Medical
                </div>
                  <div>
                    <RoomIcon className={classes.employedUnavailableIcon}></RoomIcon>Employed/Medical
                </div>
                  <div>
                    <div className={classes.clusterMarker}
                      style={{
                        width: `20px`,
                        height: `20px`,
                        margin: `4px 0 0 0`,
                        float: `left`
                      }}
                    >
                    </div><div style={{
                      float: `left`,
                      margin: `8px 0 0 4px`
                    }}>Multiple Resources</div>
                  </div>
                </div>
              </Grid>)
              :
              <Grid item xs={9}>
                <SearchModal isVisible={searchModalVisibility}
                  data={form}
                  id={cognitoUserInfo.sub}
                  headers={
                    {
                      'x-api-key': apiKey,
                      Authorization: getAuthHeader()
                    }
                  }
                  getSearchFilters={getFilters}
                  handleClose={handleSearchModalClose} />
                <Modal
                  isOpen={showPopover}
                  onRequestClose={() => setshowPopover(false)}
                  style={customStyles}
                  contentLabel="Example Modal"
                >
                  <div>
                    <h2 className={classes.popupTitleStyle}>
                      {selectedResource && selectedResource.first_name} {selectedResource && selectedResource.last_name}</h2>
                    <p className={classes.popupAttrStyle}>
                      <b>Address:</b> {selectedResource?.address_line_1}<br />
                      <b>ZipCode:</b> {selectedResource?.address_zip_code}<br />
                      <b>Available To Start:</b> {selectedResource?.available_to_start}<br />
                      <b>License Status:</b> {selectedResource?.license_status}<br />
                      <b>Relocation Status:</b> {selectedResource?.will_relocate}<br />
                      <b>Population Exp: </b>
                      {selectedResource?.population_experience?.toString()}<br />
                      <b>Specialities:</b> {selectedResource?.specialities?.toString()}<br />
                      <b>Phone:</b> {formatPhone(selectedResource?.phoneNumber)}<br />
                      <b>Email</b> {selectedResource?.email}<br />
                      <b>Start Date</b> {selectedResource?.availableToStart}<br />
                      <b>Resume</b> {(selectedResource?.resume_filename && <Link to='#' target='_self' onClick={(e) => { e.nativeEvent.stopImmediatePropagation(); downloadResume(selectedResource.email, selectedResource.resume_filename) }}>{decodeURIComponent(selectedResource.resume_filename)}</Link>) || 'None provided'}<br />
                    </p>
                    <p className={classes.popupDescStyle}>
                      <b>Licenses:</b> {formatLicenses(selectedResource?.licenses, 1)}<br />
                      <b>Recent Experience:</b> {selectedResource && selectedResource.recentExperience}<br />
                      <b>Will Treat Covid Patients:</b> {selectedResource && selectedResource.treatCovidPatients}<br />

                    </p>
                    <p className={classes.popupDescStyle}>
                      <b>Notes:</b> {selectedResource && selectedResource.NOTES}
                    </p>
                    <Button
                      onClick={() => setshowPopover(false)}
                      size="small" variant="contained">Close</Button>
                  </div>
                </Modal>
                <MaterialTable
                  icons={tableIcons}
                  onRowClick={(event, rowData: any) => {
                    setshowPopover(true)
                    setSelectedResource(rowData)
                  }}
                  columns={[
                    {
                      title: 'Name', field: 'name', cellStyle: {
                        whiteSpace: 'nowrap',
                        fontWeight: 'bold'
                      },
                      render: rowData => (
                        <span>
                          {rowData.name}
                        </span>
                      )
                    },
                    // {
                    //   title: 'License', field: 'licenses',
                    //   render: rowData => (
                    //     <span>{rowData.licenses &&
                    //       <Tooltip
                    //         title={
                    //           <React.Fragment>
                    //             {formatLicenses(rowData.licenses, 2).map((s: string) => {
                    //               return <div className={classes.columnListValue}>{s}</div>
                    //             })}
                    //           </React.Fragment>
                    //         }>
                    //         <Button>View</Button>
                    //       </Tooltip>
                    //     }
                    //     </span>
                    //   )
                    // },
                    {
                      title: 'Specialties', field: 'specialities',
                      render: rowData => (
                        <span>{rowData.specialities.split(/;+|,+/).reduce((g: string[], s: string) => {
                          if (s.trim() !== '') {
                            g.push(s);
                          }
                          return g;
                        }, []).map((s: string) => { return <div className={classes.columnListValue}>{s}</div> })
                        }
                        </span>
                      )
                    },
                    {
                      title: 'Cell Phone', field: 'phoneNumber', cellStyle: {
                        whiteSpace: 'nowrap'
                      },
                      render: rowData => (
                        <span>{formatPhone(rowData.phoneNumber)}</span>
                      )
                    },
                    { title: 'Email', field: 'email' },
                    { title: 'Start Date', field: 'availableToStart' },
                    {
                      title: 'Download Resume', field: 'resumeFilename',
                      render: rowData => (
                        <span>
                          {rowData.resumeFilename && <Link to='#' target='_self' onClick={(e) => downloadResume(rowData.email, rowData.resumeFilename)}>{decodeURIComponent(rowData.resumeFilename)}</Link>}
                        </span>
                      )
                    },
                    { title: 'Will Treat Covid Patients', field: 'treatCovidPatients' }
                  ]}
                  data={filteredResourcesProperties}
                  style={{
                    margin: '20px 10px 0 0 ',
                  }}
                  options={{
                    sorting: true,
                    search: true,
                    filtering: true,
                    headerStyle: {
                      backgroundColor: '#01579b',
                      color: '#FFF',
                      textAlign: 'center',
                    },
                    pageSize: 20,
                    padding: 'dense',
                    pageSizeOptions: [20, 40, 60, 80, 100],
                    showTitle: false,
                    toolbar: false,
                  }}
                />
              </Grid>
            }
          </Grid>
        </main>
      </LoadingOverlay>
    </div>
  );
}